import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import httpService from '../../services/httpService';

interface ProfileState {
  formData: {
    fullName: string;
    dateOfBirth: string;
    gender: string;
    qualification: string;
    language: string;
    experience: string;
    description: string;
    country: string;
    state: string;
    presentAddress: string;
    postalCode: string;
    emailId: string;
    mobileNumber: string;
  };
  image: string | null;
  saving: boolean;
  errors: Record<string, string>;
}

const initialState: ProfileState = {
  formData: {
    fullName: "",
    dateOfBirth: "",
    gender: "",
    qualification: "",
    language: "",
    experience: "",
    description: "",
    country: "",
    state: "",
    presentAddress: "",
    postalCode: "",
    emailId: '',
    mobileNumber: ''
  },
  image: null,
  saving: false,
  errors: {},
};

export const updateProfile = createAsyncThunk(
  'profile/updateProfile',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await httpService.post("/user/update-profile", payload);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.message || 'Something went wrong');
    }
  }
);

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<Partial<ProfileState['formData']>>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setImage: (state, action: PayloadAction<string | null>) => {
      state.image = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    resetProfileState: (state) => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateProfile.pending, (state) => {
        state.saving = true;
      })
      .addCase(updateProfile.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(updateProfile.rejected, (state) => {
        state.saving = false;
      });
  },
});

export const { setFormData, setImage, setErrors, resetProfileState } = profileSlice.actions;
export default profileSlice.reducer;
